import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'

import type * as models from '../models'

import { getActionsConfig } from './actions'
import { Config } from './config'
import * as effects from './effects'
import { Selectors } from './selectors'
import { State } from './state'

/**
 * TODO: add documentation
 */
export class Plugin<
  TTypeParams extends
    ec.models.TypeParams.Constraint = ec.models.TypeParams.Constraint,
> extends ec.plugins.Plugin<
  TTypeParams,
  typeof Plugin.id,
  State,
  Selectors<TTypeParams>,
  ReturnType<typeof getActionsConfig>
> {
  /** @see {@link ec.plugins.Plugin.Id.Custom} */
  public static readonly id =
    ec.plugins.Plugin.Id.Custom.create('ClipboardPlugin')

  public readonly config: Config<models.Item<any>>

  constructor({
    collection,
    config,
  }: Plugin.constructor.Params<TTypeParams, models.Item<any>>) {
    const finalConfig = Config.from(config)
    super({
      actions: getActionsConfig(collection),
      collection,
      id: Plugin.id,
      initialState: State.INITIAL,
      selectors: () => new Selectors(this),
    })
    this.config = finalConfig

    this.feature.registerEffects(
      effects.copySelected(this),
      effects.initPaste(this),
    )
  }
}
export namespace Plugin {
  export namespace constructor {
    export type Params<
      TTypeParams extends ec.models.TypeParams.Constraint,
      TItem extends models.Item<any>,
    > = Pick<Plugin<TTypeParams>, 'collection'> & {
      config: Config<TItem>
    }
  }
}
